import { useI18n } from '@change-corgi/core/react/i18n';
import { useKnownAvailableParams, useNavigate } from '@change-corgi/core/react/router';

import { usePromotePageData, usePromotePageState } from 'src/app/pages/promote/pageContext';
import { calculateImpressions } from 'src/app/shared/utils/promote';

export function useNavigateToThankYouPage(): () => void {
	const { amountToBaseUnits } = useI18n();
	const navigate = useNavigate();
	const { slug } = useKnownAvailableParams<{ slug: string }>();

	const {
		data: {
			promotionSettings: { cpm, bonusCpm, bonusThreshold },
			currency,
		},
	} = usePromotePageData();
	const [{ amount }] = usePromotePageState();

	return function navigateToThankYouPage(): void {
		const amountInUrl = amount.toString();
		navigate(
			`/p/${slug}/promote/thank_you?amount=${amountInUrl}&impressions=${calculateImpressions(
				amountToBaseUnits(amount, currency.code),
				cpm,
				bonusCpm,
				bonusThreshold,
			)}`,
		);
	};
}
